var slideIndex = 0;
showSlide(slideIndex);

function changeSlide(n) {
  slideIndex += n;
  showSlide(slideIndex);
}

function showSlide(n) {
  var slides = document.querySelectorAll("#custom-slider .slide");
  if (n >= slides.length) { slideIndex = 0; }
  if (n < 0) { slideIndex = slides.length - 1; }
  slides.forEach(slide => slide.style.display = "none");
  slides[slideIndex].style.display = "block";
}

// Auto Slide
setInterval(function(){
  changeSlide(1);
}, 4000);
